import React from 'react'
import { useWizard } from './Wizard'

type ModalFooterProps = {
  forwardButtonText?: string
  backButtonHide?: boolean // set true when you don't want a back button (eg the first and last steps in a wizard)
  handleClose?: () => void // optional EXCEPT for the final step in a wizard
  doBeforeNextStep?: () => Promise<boolean>
  showMandatoryFieldMessage?: boolean
}

export const ModalFooter = ({
  forwardButtonText,
  backButtonHide,
  handleClose,
  doBeforeNextStep,
  showMandatoryFieldMessage,
}: ModalFooterProps) => {
  const { activeStep, nextStep, previousStep, totalSteps } = useWizard()

  const handleForwardClick = async () => {
    let canGoNextStep = true
    if (doBeforeNextStep) {
      canGoNextStep = await doBeforeNextStep()
    }

    if (canGoNextStep) {
      // if handleClose is NOT provided for the last step in a wizard, an error will occur (obviously)
      activeStep === totalSteps ? handleClose() : nextStep()
    }
  }

  const stylesForwardButtonEnabled =
    'bg-[#020251] cursor-pointer text-white hover:text-[#65C2D7] shadow-[0px_1px_4px_0px_rgba(0,0,0,1)]'

  return (
    <div className={'mt-6 flex flex-col md:flex-row justify-between gap-4'}>
      <p className='text-[10px] md:text-[12px]'>
        {showMandatoryFieldMessage &&
          '* Mandatory fields are marked with an asterisk'}
      </p>
      <div className={'flex flex-row justify-end gap-4'}>
        {!backButtonHide && (
          <button
            onClick={previousStep}
            className={`rounded-[4px] !px-2 !py-1 md:!py-2 md:!px-3 leading-2 text-xs md:text-base md:font-medium md:leading-4 tracking-wide text-[#65C2D7] bg-white cursor-pointer shadow-[0px_1px_4px_0px_rgba(0,0,0,0.25)] hover:bg-[#ebfbff]`}
          >
            Back
          </button>
        )}
        <button
          type='button'
          onClick={handleForwardClick}
          className={`rounded-[4px] !px-2 !py-1 md:p-2 md:!py-2 md:!px-4 leading-2 text-xs md:text-base md:font-medium md:leading-4 tracking-wide ${stylesForwardButtonEnabled}`}
        >
          {forwardButtonText ? forwardButtonText : 'Continue'}
        </button>
      </div>
    </div>
  )
}
